/* ==========================================================================
   SoucharTap — theme JavaScript
   No dependencies. Everything here is progressive enhancement: forms submit
   and links navigate correctly with JS disabled.
   ========================================================================== */
(function () {
  'use strict';

  var T = window.SoucharTap || {};
  var routes = T.routes || {};
  var strings = T.strings || {};

  /* ---------------------------------------------------------------- utils */

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function announce(msg) {
    var live = $('#sc-live');
    if (live) { live.textContent = ''; setTimeout(function () { live.textContent = msg; }, 60); }
  }

  /**
   * Format cents using the shop's money format.
   * Handles the four Shopify placeholders; falls back to a plain
   * es-ES number if the format string is something unexpected.
   */
  function formatMoney(cents) {
    var fmt = T.moneyFormat || '{{amount_with_comma_separator}} €';
    function withDelims(num, precision, thousands, decimal) {
      if (isNaN(num) || num === null) return '0';
      num = (num / 100).toFixed(precision);
      var parts = num.split('.');
      var intPart = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var decPart = parts[1] ? decimal + parts[1] : '';
      return intPart + decPart;
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_m, name) {
      switch (name) {
        case 'amount': return withDelims(cents, 2, ',', '.');
        case 'amount_no_decimals': return withDelims(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(cents, 0, '.', ',');
        case 'amount_with_space_separator': return withDelims(cents, 2, ' ', ',');
        default: return withDelims(cents, 2, '.', ',');
      }
    });
  }

  /* --------------------------------------------------------- focus helpers */

  var lastFocused = null;

  function trapFocus(container) {
    var sel = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea,[tabindex]:not([tabindex="-1"])';
    function onKey(e) {
      if (e.key !== 'Tab') return;
      var items = $$(sel, container).filter(function (el) { return el.offsetParent !== null; });
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    container.addEventListener('keydown', onKey);
    return function () { container.removeEventListener('keydown', onKey); };
  }

  var releaseTrap = null;

  function openOverlay(el) {
    lastFocused = document.activeElement;
    el.setAttribute('data-open', 'true');
    document.body.classList.add('sc-no-scroll');
    releaseTrap = trapFocus(el);
    var focusable = $('button, a[href], select, input', el);
    if (focusable) setTimeout(function () { focusable.focus(); }, 60);
  }

  function closeOverlay(el) {
    el.setAttribute('data-open', 'false');
    document.body.classList.remove('sc-no-scroll');
    if (releaseTrap) { releaseTrap(); releaseTrap = null; }
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  /* --------------------------------------------------------- mobile menu */

  function initMobileMenu() {
    var nav = $('[data-sc-mobile-nav]');
    if (!nav) return;
    var opener = $('[data-sc-menu-open]');

    $$('[data-sc-menu-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        openOverlay(nav);
        btn.setAttribute('aria-expanded', 'true');
      });
    });
    $$('[data-sc-menu-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        closeOverlay(nav);
        if (opener) opener.setAttribute('aria-expanded', 'false');
      });
    });
    // Close when navigating to an in-page anchor.
    $$('a', nav).forEach(function (a) {
      a.addEventListener('click', function () {
        closeOverlay(nav);
        if (opener) opener.setAttribute('aria-expanded', 'false');
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.getAttribute('data-open') === 'true') {
        closeOverlay(nav);
        if (opener) opener.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* -------------------------------------------------------------- toast */

  var toastTimer = null;
  function toast(msg) {
    var el = $('[data-sc-toast]');
    if (!el) { announce(msg); return; }
    $('[data-sc-toast-text]', el).textContent = msg;
    el.setAttribute('data-show', 'true');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.setAttribute('data-show', 'false'); }, 3200);
  }

  /* --------------------------------------------------------- cart drawer */

  var DRAWER_SECTION = 'souchar-cart-drawer';

  /**
   * The Cart AJAX API only guarantees JSON on the `.js` endpoints, and only
   * those endpoints accept a `sections` parameter that renders the drawer in
   * the same round trip. `routes.*` give the plain paths, so add the suffix.
   */
  function ajaxUrl(url) {
    return (url || '').replace(/\.js$/, '') + '.js';
  }

  function parseJSON(res) {
    return res.json().then(function (body) {
      if (!res.ok) throw new Error((body && (body.description || body.message)) || strings.addError);
      return body;
    });
  }

  var Cart = {
    drawer: function () { return $('[data-sc-drawer]'); },

    open: function () {
      var d = this.drawer();
      if (d) openOverlay(d);
    },

    close: function () {
      var d = this.drawer();
      if (d) closeOverlay(d);
    },

    /** Swap in freshly rendered drawer markup. Returns false if there is none. */
    render: function (html) {
      if (!html) return false;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = $('[data-sc-drawer]', doc);
      var current = Cart.drawer();
      if (!fresh || !current) return false;
      var wasOpen = current.getAttribute('data-open');
      current.innerHTML = fresh.innerHTML;
      current.setAttribute('data-open', wasOpen);
      Cart.bindDrawer();
      return true;
    },

    /**
     * Apply the `sections` payload a cart mutation returns. Falls back to a
     * standalone render request if the section came back empty.
     */
    apply: function (body) {
      var sections = (body && body.sections) || {};
      var rendered = Cart.render(sections[DRAWER_SECTION]);
      if (body && typeof body.item_count === 'number') {
        Cart.updateBadge(body.item_count);
        return rendered ? Promise.resolve() : Cart.refresh();
      }
      // /cart/add.js answers with the line item, which carries no item_count.
      return Cart.count().then(function () {
        return rendered ? undefined : Cart.refresh();
      });
    },

    count: function () {
      return fetch(ajaxUrl(routes.cart_url), { headers: { Accept: 'application/json' } })
        .then(parseJSON)
        .then(function (cart) { Cart.updateBadge(cart.item_count); });
    },

    /**
     * Standalone re-render, used when a mutation response carries no sections.
     * No Accept header on purpose: `Accept: application/json` makes Shopify
     * answer /cart with the cart JSON and ignore `?sections=` entirely.
     */
    refresh: function () {
      return fetch(routes.cart_url + '?sections=' + DRAWER_SECTION)
        .then(function (r) { return r.json(); })
        .then(function (data) { Cart.render(data[DRAWER_SECTION]); })
        .catch(function () { /* the badge below is the part that matters */ })
        .then(function () { return Cart.count(); });
    },

    updateBadge: function (count) {
      $$('[data-sc-cart-count]').forEach(function (b) {
        b.textContent = count;
        if (count > 0) b.removeAttribute('hidden'); else b.setAttribute('hidden', '');
      });
    },

    change: function (line, quantity) {
      return fetch(ajaxUrl(routes.cart_change_url), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          line: line,
          quantity: quantity,
          sections: DRAWER_SECTION,
          sections_url: window.location.pathname
        })
      }).then(parseJSON).then(function (cart) { return Cart.apply(cart); });
    },

    add: function (formData) {
      formData.append('sections', DRAWER_SECTION);
      formData.append('sections_url', window.location.pathname);
      return fetch(ajaxUrl(routes.cart_add_url), {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      }).then(parseJSON);
    },

    /** (Re)attach listeners to drawer contents after each re-render. */
    bindDrawer: function () {
      var d = Cart.drawer();
      if (!d) return;

      $$('[data-sc-drawer-close]', d).forEach(function (el) {
        el.addEventListener('click', function () { Cart.close(); });
      });

      $$('[data-sc-qty]', d).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var line = parseInt(btn.getAttribute('data-sc-line-target'), 10);
          var delta = parseInt(btn.getAttribute('data-sc-qty'), 10);
          var input = $('[data-sc-qty-input][data-sc-line-target="' + line + '"]', d);
          var next = Math.max(0, (parseInt(input.value, 10) || 0) + delta);
          btn.disabled = true;
          Cart.change(line, next);
        });
      });

      $$('[data-sc-qty-input]', d).forEach(function (input) {
        input.addEventListener('change', function () {
          var line = parseInt(input.getAttribute('data-sc-line-target'), 10);
          Cart.change(line, Math.max(0, parseInt(input.value, 10) || 0));
        });
      });

      $$('[data-sc-remove]', d).forEach(function (btn) {
        btn.addEventListener('click', function () {
          Cart.change(parseInt(btn.getAttribute('data-sc-remove'), 10), 0);
        });
      });
    }
  };

  function initCart() {
    Cart.bindDrawer();

    // The cart icon opens the drawer; without JS it stays a link to /cart.
    $$('[data-sc-cart-toggle]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        if (!Cart.drawer()) return;
        e.preventDefault();
        Cart.open();
      });
    });

    document.addEventListener('keydown', function (e) {
      var d = Cart.drawer();
      if (e.key === 'Escape' && d && d.getAttribute('data-open') === 'true') Cart.close();
    });
  }

  /* ------------------------------------------------ async add-to-cart forms */

  /**
   * Guard against double-binding. boot() re-runs on shopify:section:load, and
   * without this an add-to-cart form would fire one request per reload.
   */
  function once(el, key) {
    var flag = 'scBound' + key;
    if (el.dataset[flag]) return false;
    el.dataset[flag] = '1';
    return true;
  }

  function initAddForms() {
    $$('form[data-sc-add-form]').forEach(function (form) {
      if (!once(form, 'Add')) return;
      form.addEventListener('submit', function (e) {
        // Let the browser do a normal POST if the builder says it's invalid.
        if (form.getAttribute('data-sc-invalid') === 'true') return;

        e.preventDefault();
        var btn = $('[data-sc-submit]', form);
        var errBox = $('[data-sc-error]', form);
        if (errBox) errBox.textContent = '';
        if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.dataset.label = btn.textContent; }

        Cart.add(new FormData(form))
          .then(function (body) { return Cart.apply(body); })
          .then(function () {
            toast(strings.added || '¡Añadido!');
            announce(strings.added || '');
            Cart.open();
          })
          .catch(function (err) {
            var msg = err.message || strings.addError;
            if (errBox) errBox.textContent = msg;
            announce(msg);
          })
          .finally(function () {
            if (btn) { btn.removeAttribute('aria-disabled'); if (btn.dataset.label) btn.textContent = btn.dataset.label; }
          });
      });
    });
  }

  /* ------------------------------------------------------ quantity steppers */

  function initQtySteppers() {
    $$('[data-sc-qty-widget]').forEach(function (widget) {
      if (!once(widget, 'Qty')) return;
      var input = $('input', widget);
      $$('button[data-step]', widget).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var delta = parseInt(btn.getAttribute('data-step'), 10);
          var min = parseInt(input.getAttribute('min'), 10) || 1;
          var next = Math.max(min, (parseInt(input.value, 10) || min) + delta);
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ============================================================ PACK BUILDER
     Tier radios drive:
       - which variant id gets posted
       - how many product slots are visible
       - the live price on the submit button
     Every slot is posted as a line-item property (Producto 1, Producto 2, …)
     so the contents show up in the cart, the checkout and the admin order.
     ========================================================================= */

  function initPackBuilder() {
    $$('[data-sc-pack]').forEach(function (root) {
      if (!once(root, 'Pack')) return;
      var form = root.closest('form');
      var tiers = $$('[data-sc-tier]', root);
      var slotsWrap = $('[data-sc-slots]', root);
      var slotList = $('[data-sc-slot-list]', root);
      var legendCount = $('[data-sc-slot-count]', root);
      var submitLabel = $('[data-sc-submit-label]', root);
      var qtyInput = $('[data-sc-qty-widget] input', root);
      if (!tiers.length) return;

      // Template options come from the collection, rendered once server-side.
      var optionSource = $('[data-sc-slot-options]', root);
      var optionsHTML = optionSource ? optionSource.innerHTML : '';

      function selectedTier() {
        return tiers.filter(function (t) { return t.checked; })[0] || null;
      }

      /* Thumbnail of the product a slot has selected. The URL rides on each
         <option> as data-img, put there by the section from the product's
         featured image, so changing a photo in the admin is enough — no code
         change here. Products with no image get a neutral placeholder rather
         than a broken <img>. */
      var EMPTY_THUMB =
        '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" ' +
        'stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<rect x="3" y="4" width="18" height="16" rx="2"/><circle cx="8.5" cy="9.5" r="1.5"/>' +
        '<path d="m4 18 5-5 4 4 3-3 4 4"/></svg>';

      function paintThumb(select) {
        var field = select.parentElement;
        if (!field) return;

        var opt = select.selectedOptions ? select.selectedOptions[0] : select.options[select.selectedIndex];
        var src = opt ? opt.getAttribute('data-img') : '';
        var old = $('.sc-slot__thumb', field);
        var wanted = src ? 'IMG' : 'SPAN';
        var thumb = old;

        // The placeholder is a <span>, the photo an <img>, so swap the node
        // when the selection crosses between the two.
        if (!thumb || thumb.tagName !== wanted) {
          thumb = document.createElement(src ? 'img' : 'span');
          if (src) {
            thumb.width = 80;
            thumb.height = 80;
            thumb.decoding = 'async';
            /* Deliberately NOT loading="lazy": these are six 96px thumbnails
               high up the page, and a lazy image built by script can sit
               unfetched even while on screen — which shows an empty box where
               the photo should be. Nothing to gain, a blank slot to lose. */
            thumb.alt = '';  // Decorative: the product name is in the select.
          } else {
            thumb.setAttribute('aria-hidden', 'true');
          }
          if (old) field.replaceChild(thumb, old);
          else field.insertBefore(thumb, select);
        }

        if (src) {
          thumb.className = 'sc-slot__thumb';
          thumb.src = src;
        } else {
          thumb.className = 'sc-slot__thumb sc-slot__thumb--empty';
          thumb.innerHTML = EMPTY_THUMB;
        }
      }

      function buildSlots(count) {
        if (!slotList) return;
        var previous = $$('select', slotList).map(function (s) { return s.value; });
        slotList.innerHTML = '';

        for (var i = 1; i <= count; i++) {
          var row = document.createElement('div');
          row.className = 'sc-slot';

          var num = document.createElement('span');
          num.className = 'sc-slot__num';
          num.setAttribute('aria-hidden', 'true');
          num.textContent = i;

          var field = document.createElement('span');
          field.className = 'sc-slot__field';

          var select = document.createElement('select');
          select.className = 'sc-slot__select';
          select.name = 'properties[' + (root.dataset.slotPrefix || 'Producto') + ' ' + i + ']';
          select.required = true;
          select.setAttribute('aria-label', (root.dataset.slotLabel || 'Producto') + ' ' + i);
          select.innerHTML = optionsHTML;
          if (previous[i - 1]) select.value = previous[i - 1];

          var chev = document.createElement('span');
          chev.className = 'sc-slot__chev';
          chev.innerHTML =
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" ' +
            'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
            '<path d="m6 9 6 6 6-6"/></svg>';

          field.appendChild(select);
          field.appendChild(chev);
          row.appendChild(num);
          row.appendChild(field);
          slotList.appendChild(row);

          paintThumb(select);
          select.addEventListener('change', function (e) { paintThumb(e.target); });
        }

        if (legendCount) legendCount.textContent = count;
        if (slotsWrap) slotsWrap.hidden = count < 1;
      }

      function updatePrice() {
        var tier = selectedTier();
        if (!tier || !submitLabel) return;
        var unit = parseInt(tier.dataset.price, 10) || 0;
        var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
        submitLabel.textContent = (root.dataset.buyLabel || 'Comprar') + ' · ' + formatMoney(unit * qty);
      }

      function sync() {
        var tier = selectedTier();
        if (!tier) return;
        buildSlots(parseInt(tier.dataset.units, 10) || 0);
        updatePrice();
      }

      tiers.forEach(function (t) { t.addEventListener('change', sync); });
      if (qtyInput) qtyInput.addEventListener('change', updatePrice);

      // Guard: never post a pack with an empty slot.
      if (form) {
        form.addEventListener('submit', function (e) {
          var empty = $$('select', slotList || root).filter(function (s) { return !s.value; });
          if (empty.length) {
            e.preventDefault();
            e.stopImmediatePropagation();
            var errBox = $('[data-sc-error]', form);
            if (errBox) errBox.textContent = strings.slotRequired;
            empty[0].focus();
          }
        }, true);
      }

      sync();
    });
  }

  /* ------------------------------------------------------- PDP image switch */

  function initGallery() {
    $$('[data-sc-gallery]').forEach(function (gal) {
      if (!once(gal, 'Gal')) return;
      var main = $('[data-sc-gallery-main]', gal);
      $$('[data-sc-gallery-thumb]', gal).forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var full = thumb.getAttribute('data-full');
          var srcset = thumb.getAttribute('data-srcset') || '';
          var alt = thumb.getAttribute('data-alt') || '';
          /* El srcset gana al src: si solo se cambiara src, el navegador
             seguiría pintando la foto anterior. Se reescriben los dos. */
          if (main && full) { main.srcset = srcset; main.src = full; main.alt = alt; }
          $$('[data-sc-gallery-thumb]', gal).forEach(function (t) { t.setAttribute('aria-current', 'false'); });
          thumb.setAttribute('aria-current', 'true');
        });
      });
    });
  }

  /* ------------------------------------------------- carruseles (galería y opiniones) */

  /**
   * Un solo carrusel para la galería de fotos y para las opiniones. El carril
   * ya desplaza solo con CSS (scroll-snap), así que esto únicamente añade
   * flechas y puntos: si el JS no llega, la sección sigue siendo usable y esos
   * controles ni se pintan (.no-js).
   */
  function initCarousels() {
    $$('[data-sc-car]').forEach(function (car) {
      if (!once(car, 'Car')) return;

      var track = $('[data-sc-car-track]', car);
      var prev = $('[data-sc-car-prev]', car);
      var next = $('[data-sc-car-next]', car);
      var dotsBox = $('[data-sc-car-dots]', car);
      if (!track || !prev || !next || !dotsBox) return;

      var items = Array.prototype.slice.call(track.children);
      if (!items.length) return;

      function step() {
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return items[0].getBoundingClientRect().width + gap;
      }
      // Cuántas fotos caben enteras: el CSS decide 3, 2 o 1 según el ancho.
      function perView() { return Math.max(1, Math.round(track.clientWidth / step())); }
      function pages() { return Math.max(1, Math.ceil(items.length / perView())); }

      var dots = [];

      function buildDots() {
        dotsBox.innerHTML = '';
        dots = [];
        var total = pages();
        if (total < 2) return;
        for (var i = 0; i < total; i++) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'sc-car__dot';
          b.setAttribute('data-page', i);
          b.setAttribute(
            'aria-label',
            (strings.carouselGroup || 'Ir al grupo {{ index }} de {{ total }}')
              .replace('{{ index }}', i + 1)
              .replace('{{ total }}', total)
          );
          b.addEventListener('click', function () {
            var p = parseInt(this.getAttribute('data-page'), 10);
            track.scrollTo({ left: p * perView() * step(), behavior: 'smooth' });
          });
          dotsBox.appendChild(b);
          dots.push(b);
        }
      }

      function sync() {
        var page = Math.round(track.scrollLeft / (step() * perView()));
        dots.forEach(function (d, i) {
          d.setAttribute('aria-current', i === page ? 'true' : 'false');
        });
        prev.disabled = track.scrollLeft < 4;
        next.disabled = track.scrollLeft > track.scrollWidth - track.clientWidth - 4;
      }

      function move(dir) {
        track.scrollBy({ left: dir * step() * perView(), behavior: 'smooth' });
      }

      function refresh() { buildDots(); sync(); }

      prev.addEventListener('click', function () { move(-1); });
      next.addEventListener('click', function () { move(1); });
      track.addEventListener('scroll', sync, { passive: true });

      /* El número de puntos depende de cuántas fotos caben, así que se
         recalcula cada vez que el carril cambia de ancho — incluido el momento
         en que acaban de cargar las fuentes y las imágenes. */
      if (window.ResizeObserver) {
        new ResizeObserver(refresh).observe(track);
      } else {
        window.addEventListener('resize', refresh);
      }
      window.addEventListener('load', refresh);
      refresh();
    });
  }

  /* -------------------------------------------------------------- countdown */

  function initCountdown() {
    $$('[data-sc-countdown]').forEach(function (el) {
      if (!once(el, 'Cd')) return;
      var hours = parseFloat(el.getAttribute('data-hours')) || 8;
      var span = hours * 3600 * 1000;
      // Anchor to a rolling window so the timer never shows a dead 00:00:00.
      function tick() {
        var now = Date.now();
        var remaining = span - (now % span);
        var h = Math.floor(remaining / 3600000);
        var m = Math.floor((remaining % 3600000) / 60000);
        var s = Math.floor((remaining % 60000) / 1000);
        el.textContent = String(h).padStart(2, '0') + ':' + String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  /* --------------------------------------------------------- reveal on scroll */

  function initReveal() {
    if (!('IntersectionObserver' in window)) {
      $$('.sc-reveal').forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      $$('.sc-reveal').forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-in'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    $$('.sc-reveal').forEach(function (el) { io.observe(el); });
  }

  /* -------------------------------------------------------- collection filter */

  function initFilters() {
    $$('[data-sc-filters]').forEach(function (bar) {
      if (!once(bar, 'Filt')) return;
      var grid = $('[data-sc-filter-grid]');
      if (!grid) return;
      $$('[data-sc-filter]', bar).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var value = btn.getAttribute('data-sc-filter');
          $$('[data-sc-filter]', bar).forEach(function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
          $$('[data-sc-tile]', grid).forEach(function (tile) {
            var tags = (tile.getAttribute('data-tags') || '').split(' ');
            tile.hidden = value !== 'all' && tags.indexOf(value) === -1;
          });
          var shown = $$('[data-sc-tile]', grid).filter(function (t) { return !t.hidden; }).length;
          announce(shown + ' productos');
        });
      });
    });
  }

  /* ------------------------------------------------------------------- boot */

  function boot() {
    initMobileMenu();
    initCart();
    // Order matters: the pack builder's validation listener must be registered
    // before the async add-to-cart listener on the same form, so an incomplete
    // pack is stopped before any request goes out.
    initPackBuilder();
    initAddForms();
    initQtySteppers();
    initGallery();
    initCarousels();
    initCountdown();
    initReveal();
    initFilters();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init when the Theme Editor swaps a section.
  document.addEventListener('shopify:section:load', boot);
})();
